import { useUserValidations } from '@/composables/useUserValidations';

export default function (): boolean {
  const { $debug } = useNuxtApp();

  try {
    const { isEmailVerified, isNeedToValidateEmail } = useUserValidations();
    const { userRegisteredAt, isNewUserToValidate } = useUserData();

    const checkEmailRules = computed(() => {
      if (isNewUserToValidate.value) {
        return isEmailVerified.value;
      }

      return !isNeedToValidateEmail.value;
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('📧 ~ EMAIL VALIDATION:\n');
      console.debug('📧 ~ userRegisteredAt:', userRegisteredAt.value);
      console.debug('📧 ~ isNewUserToValidate:', isNewUserToValidate.value);
      console.debug(
        '📧 ~ isEmailVerified (validate_email_at):',
        isEmailVerified.value,
      );
      console.debug(
        '📧 ~ isNeedToValidateEmail (seven_days_since_last_login):',
        isNeedToValidateEmail.value,
      );

      coloredDebug(checkEmailRules.value);
      console.groupEnd();
    }

    return checkEmailRules.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.error(err);
    }

    return false;
  }
}
